<h1 mat-dialog-title>Selecione uma Empresa</h1>
<div mat-dialog-content>
  <app-business-selection
    (businessSelected)="businessSelected($event)"
  ></app-business-selection>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="warn">Cancelar</button>
</div>
